import * as React from 'react'
import { Ref, forwardRef } from 'react'

import { Box, Icon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface DropItemProps {
  isOver: boolean
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
}

const DropItem = ({ isOver, icon }: DropItemProps, ref: Ref<HTMLDivElement>) => {
  return (
    <Box
      background="grey100"
      alignItems="center"
      justifyContent="center"
      maxWidth="widePage"
      padding="s4"
      width="full"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: isOver ? 'malibu1000' : 'grey100',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      ref={ref}
    >
      <Box
        height="s24"
        width="s24"
        background={isOver ? 'grey000White' : 'grey100'}
        borderRadius={isOver ? { all: 'rel1000' } : undefined}
        boxShadow={isOver ? 's200' : undefined}
        alignItems="center"
        justifyContent="center"
      >
        <Icon.Medium color="grey1000" icon={icon} />
      </Box>
    </Box>
  )
}

export default observer(forwardRef(DropItem))
